export default {
	errors(errors, field) {
		return Object.fromEntries(Object.entries(errors).filter(([key]) => {
			return key.includes(field)
		}).map(([key, value]) => {
			return [key.replace(field + '.', ''), value]
		}));
	}
};